// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';

// Firebase configuration
// IMPORTANT: Replace with your Firebase project credentials
const firebaseConfig = {
  apiKey: "AIzaSyB6EP1P2lvkCh4eJFZQlMOup69dFXSXG2c",
  authDomain: "petrolnaija1.firebaseapp.com",
  projectId: "petrolnaija1",
  storageBucket: "petrolnaija1.firebasestorage.app",
  messagingSenderId: "378778783591",
  appId: "1:378778783591:web:789bb059484661a205a9c2"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
export const db = getFirestore(app);

// Initialize Auth
export const auth = getAuth(app);

// Google Auth Provider
export const googleProvider = new GoogleAuthProvider();

// Admin email - only this email has admin access
export const ADMIN_EMAIL = 'ngfmcontacts@gmail.com';
